import React from 'react';

import StatusBox from 'components/StatusBox';

const GENERATED = 'generated';
const PENDING = 'pending';

const RATE_PLAN_STATUSES_COLORS = {
  [GENERATED]: StatusBox.GREEN,
  [PENDING]: StatusBox.ORANGE
};

interface RentPlanStatusBoxProps {
  hasRentSchedule: boolean;
}

class RentPlanStatusBox extends React.Component<RentPlanStatusBoxProps> {
  render() {
    const {hasRentSchedule} = this.props;

    const status = hasRentSchedule ? GENERATED : PENDING;

    return (
      <StatusBox color={RATE_PLAN_STATUSES_COLORS[status]} status={status} />
    );
  }
}

export default RentPlanStatusBox;
